import { memo } from "react";
import { useTranslation } from "react-i18next";
import { Label } from "@/components/ui/label";
import { ReadContractorCard } from "@/types/contractorCard";
import DescriptionList from "@/components/description-list/DescriptionList";
import { CardRequireBadge } from "../shared/components";

interface CardDetailsSectionProps {
  contractorCard: ReadContractorCard;
}

export const CardDetailsSection = memo(
  ({ contractorCard }: CardDetailsSectionProps) => {
    const { t } = useTranslation();

    return (
      <DescriptionList
        data={contractorCard}
        translationKey="contractorCards"
        className="mb-6"
      >
        <DescriptionList.Header>
          <DescriptionList.Title name="project_name" />
        </DescriptionList.Header>
        <DescriptionList.Content>
          <DescriptionList.Item name="project_name" />
          <DescriptionList.Item name="store_name" />
          <DescriptionList.Item name="period" />
          <div className="flex flex-col gap-1">
            <Label className="text-sm font-medium">
              {t("contractorCards.fields.contractor_card_required")}
            </Label>
            <span className="text-sm text-muted-foreground">
              <CardRequireBadge
                required={contractorCard.contractor_card_required}
              />
            </span>
          </div>
        </DescriptionList.Content>
      </DescriptionList>
    );
  },
);
